import { Button } from "@/src/components/ui/Button";
import { Text } from "@/src/components/ui/Typography";
import { cn } from "@/src/lib/utils";

interface UseCaseListItemProps {
  number: string;
  title: string;
  active: boolean;
  onSelect: () => void;
}

export function UseCaseListItem({ number, title, active, onSelect }: UseCaseListItemProps) {
  return (
    <Button
      type="button"
      unstyled
      onClick={onSelect}
      aria-pressed={active}
      className="group flex w-full items-baseline gap-4 border-l-2 py-2.5 pl-4 text-left transition-colors duration-300"
      style={{ borderColor: active ? "var(--color-brand)" : "transparent" }}
    >
      <Text
        as="span"
        size="labelMD"
        className={cn(
          "shrink-0 transition-colors duration-300",
          active ? "text-brand" : "text-neutral-400 group-hover:text-neutral-500",
        )}
      >
        {number}
      </Text>

      <Text
        as="span"
        size="bodyMD"
        className={cn(
          "transition-colors duration-300",
          active ? "text-neutral-700" : "text-neutral-500 group-hover:text-neutral-700",
        )}
      >
        {title}
      </Text>
    </Button>
  );
}
